module.exports = __webpack_public_path__ + "static/browser_yamaha_small-260c5585b544a13e61d0d43463348dcf.png";